import { useMemo } from 'react';

import { TeamMember } from '@this+that/models';

import { useTeamMembers } from '../context/TeamMembersContext';

export function useActiveParticipants(
  participantIds: string[] | null | undefined,
): TeamMember[] {
  const { state } = useTeamMembers();

  return useMemo(
    () =>
      state.teamMembers.filter((m) => (participantIds ?? []).includes(m.id)),
    [participantIds, state.teamMembers],
  );
}
